import React from 'react'
import FeedElement from './FeedElement'

function Freelancer() {
    return (
        <FeedElement type="freelancer" />
    )
}

export default Freelancer